<template>
  <div class="col-md-7 login-left d-none d-md-block">
    <div class="h-full d-flex flex-column align-items-center justify-content-between">
      <a :href="getClientAppUrl" target="_blank"><img class="login-logo pointer" src="../../../assets/img/white-1x.png" /></a>
      <div>
        <img class="login-pc" src="../../../assets/img/login-pc.svg" />
        <div class="under-pc-text">Track all your moves in one place</div>
      </div>
      <a class="changed-router-links pointer" :href="getForemanUrl" target="_blank"><div class="foreman-retangle row align-items-center">
        <div class="col-md-3 foreman">Are you a foreman?</div>
        <div class="col-md-8 foreman-desscription-txt">We’re currently working on a native app for Android and iOS. For now you can login to your account and track moves on our web app.</div>
        <div class="col-md-1 foreman-arrow"><i class="fa fa-long-arrow-right" /></div>
      </div></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutLeftAuth',
  computed: {
    getClientAppUrl() {
      if (process.env.NODE_ENV === 'develop') {
        return 'https://frontend.mod24.com/company';
      }
      return 'https://mod24.com/company';
    },
    getForemanUrl() {
      if (process.env.NODE_ENV === 'develop') {
        return 'https://ma.24mod.com';
      }
      return 'https://movers.mod24.com';
    },
  },
};
</script>
<style scoped>
.login-left {
  background: rgb(41, 98, 255);
  background: radial-gradient(
    circle,
    rgba(41, 98, 255, 1) 10%,
    rgba(27, 81, 171, 1) 60%,
    rgba(17, 48, 102, 1) 100%
  );
  height: 100vh;
  color: white;
  box-shadow: 4px 0px 6px rgba(0, 0, 0, 0.25);
}
.login-logo {
  height: 40px;
  width: 107px;
  margin-top: 60px;
}
.login-pc {
  height: 196px;
  width: 219px;
  margin-bottom: 66px;
}
.under-pc-text {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
}
.foreman-retangle {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 20px;
  bottom: 40px;
  width: 100%;
  margin-bottom: 40px;
}
.foreman {
  font-size: 16px;
  line-height: 24px;
}
.foreman-desscription-txt {
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.0875px;
}
.foreman-arrow a {
  color: white;
}
a {
  text-decoration: none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/components/LayoutLeftAuth.vue